import React, { useCallback, useEffect, useRef, useState } from 'react';

import styled, { css } from 'styled-components';

import BottomSheet, {
  BOTTOM_SHEET_DEFAULT_TRANSITION_PROPS_TIMINGS,
  BottomSheetRef,
} from '../FilterDrawerV2/BottomSheet';

import { Component as StyleContext } from '../StyleContext';

import BraCalculator from './BraCalculator';

const bottomSheetStyling = {
  closeIconStyling: css`
    stroke: ${({ theme }) => theme.colors.black};
  `,
  headerStyling: css`
    border: none;
  `,
};

const ContentWrapper = styled.div`
  width: 100%;
  height: auto;
  padding: 0 ${({ theme }) => theme.spacing.small}px;
  transform: translateY(-48px);
`;

interface BraCalculatorDrawerProps {
  isOpen?: boolean;
  setShowBraCalculatorDrawer: (isOpen: boolean) => void;
  handleShopMySize: (...args: any[]) => void;
}

export default function BraCalculatorDrawer({
  isOpen = false,
  setShowBraCalculatorDrawer,
  handleShopMySize: handleShopMySizeSubmit,
}: BraCalculatorDrawerProps) {
  const sheetRef = useRef<BottomSheetRef>(null);

  const [isClosing, setIsClosing] = useState(false);

  const handleCloseDrawer = useCallback(() => {
    if (!isClosing) {
      setIsClosing(true);

      // Wait for animation to complete before notifying parent
      setTimeout(() => {
        setShowBraCalculatorDrawer(false);
        setIsClosing(false);
      }, BOTTOM_SHEET_DEFAULT_TRANSITION_PROPS_TIMINGS.exit + 50);
    }
  }, [isClosing, setShowBraCalculatorDrawer]);

  const onClose = useCallback(() => {
    handleCloseDrawer();
  }, [handleCloseDrawer]);

  useEffect(() => {
    if (!isOpen && sheetRef.current?.isOpened && !isClosing) {
      sheetRef.current?.close();
      setIsClosing(true);
      setTimeout(
        () => setIsClosing(false),
        BOTTOM_SHEET_DEFAULT_TRANSITION_PROPS_TIMINGS.exit + 50
      );
    }
    if (isOpen && !sheetRef.current?.isOpened) {
      sheetRef.current?.open();
    }
  }, [isClosing, isOpen]);

  const handleShopMySize = useCallback(
    (...args) => {
      sheetRef.current?.close();
      handleShopMySizeSubmit(...args);
    },
    [handleShopMySizeSubmit]
  );

  return (
    <div data-autotag="bra-calculator-overlay">
      <BottomSheet
        footer={null}
        onClose={onClose}
        title=""
        ref={sheetRef}
        styles={bottomSheetStyling}
        showHeaderSeparator={false}
        contentPadding={0}
        detente={0.95}
      >
        <StyleContext context="braCalculator">
          <ContentWrapper>
            <BraCalculator
              handleShopMySize={handleShopMySize}
              activeTabFromProps="sizeChart"
              reverseTabs
            />
          </ContentWrapper>
        </StyleContext>
      </BottomSheet>
    </div>
  );
}
